import Vuex from "vuex";

const state = {
  showPhone: false,
}

const actions = {

}

const mutations = {
  toggle(state, param) {
    state.showPhone = param;
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/header.js